import React, { useEffect, useState, useCallback, useMemo } from "react";
import AppointmentCounts from "../components/AppointmentCounts";
import AppointmentFilter from "../components/AppointmentFilter";
import AppointmentTr from "../components/AppointmentTr";
import baseUrl from "../../../../../api/baseUrl";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import {
  setMyAppointment,
  setMyAppointmentCount,
} from "../../../../../redux/appointment/appointmentAction";
import { io, Socket } from "socket.io-client";
import socketauth from "../../../../../api/socket";
import BottomTab from "../../../../../components/pagination/BottomTab";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
const socket: Socket = io(`${process.env.REACT_APP_WS}`, socketauth);
function YourAppointment() {
  const [all, setAll] = useState("all");
  const [selectedOption, setSelectedOption] = useState<string>("pending");
  const dispatch = useDispatch();
  const appointment = useSelector((state: RootState) => state.appointment);
  const [counts, setCounts] = useState(0);
  const getAppointments = useCallback(
    (status: string, all: string, newPage?: number) => {
      baseUrl
        .get("/appointment/findAllAppointmentDentistId", {
          headers: {
            status: status,
            day: all,
            page: newPage,
          },
        })
        .then((response) => {
          setCounts(response.data.count);
          dispatch(setMyAppointment(response.data.data, false));
        })
        .catch((error) => {
          console.error(error);
        });
    },
    []
  );

  const appointmentCount = useCallback(() => {
    baseUrl
      .get("/appointment/appointmentscountsbyId", {
        headers: {
          status: true,
        },
      })
      .then((response) => {
        dispatch(
          setMyAppointmentCount({
            appointments: response.data?.appointments,
            cancelled: response.data?.cancelled,
            completed: response.data?.completed,
            pending: response.data?.pending,
            inqueue: response.data?.inqueue,
            reschudle: response.data?.reschudle,
            ongoing: response.data?.ongoing,
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    if (appointment?.myappointmentIsEMpty) getAppointments(selectedOption, all,1);
    if (appointment?.myappointmentIsEMpty) appointmentCount();
  }, [getAppointments, appointmentCount, selectedOption, all]);

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const status = event.target.value;
    setSelectedOption(status);
    getAppointments(status, all,1);
  };

  const handleDay = (event: React.ChangeEvent<HTMLInputElement>) => {
    const day = event.target.value;
    setAll(day);
    getAppointments(selectedOption, day,1);
  };

  const appointmentRows = useMemo(
    () =>
      appointment?.myappointment?.map((item: any, index: number) => (
        <AppointmentTr
          appointmStatus={() => {
            getAppointments(selectedOption, all);
            appointmentCount();
          }}
          key={index}
          item={item}
        />
      )),
    [appointment, selectedOption, all, getAppointments, appointmentCount]
  );
  const onPageChange = useCallback(
    (newPage: number) => {
      getAppointments(selectedOption, all, newPage);
    },
    [getAppointments, all, selectedOption]
  );

  
  return (
    <div className="">
      <AppointmentCounts count={appointment?.myappointmentCount} />
      <div className="bg-white rounded-xl md:rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 p-4 md:p-6">
        <AppointmentFilter
          selectedOption={selectedOption}
          all={all}
          handleOptionChange={handleOptionChange}
          handleDay={handleDay}
        />
        {/* Desktop Table */}
        <div className="hidden md:block overflow-hidden rounded-xl border border-slate-200">
          <table className="w-full">
            <thead className="bg-gradient-to-r from-slate-50 to-slate-100 border-b-2 border-slate-200">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Patient Name</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Date</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Time Slot</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Status</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Purpose</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Type</th>
                <th className="px-6 py-4 text-center text-xs font-bold text-slate-700 uppercase tracking-wider w-32">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-100">{appointmentRows}</tbody>
          </table>
        </div>
        {/* Mobile Cards */}
        <div className="md:hidden space-y-3">
          {appointment?.myappointment?.map((item: any, index: number) => (
            <div key={index} className="bg-white rounded-xl border border-slate-200 p-4 space-y-3 hover:shadow-md transition-shadow">
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-base text-slate-900 mb-1 truncate">
                    {item?.patientId?.fullName || item?.bookPatientId?.fullName || "N/A"}
                  </h3>
                  <p className="text-xs text-slate-500">{item?.date?.split("T")[0]}</p>
                </div>
                <div className="flex gap-1.5 flex-shrink-0">
                  {item?.patientId?.fullName && (
                    <>
                      <button
                        onClick={() => window.location.href = `/client/patients/patientone/general-detail/${item?.patientId?._id}`}
                        className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center hover:bg-indigo-100 transition-colors"
                        title="View Patient"
                      >
                        <RemoveRedEyeIcon sx={{ fontSize: 18 }} />
                      </button>
                      <button
                        onClick={(e: any) => {
                          e.stopPropagation();
                          baseUrl.post("treatment/create-treatment", { patientId: item?.patientId?._id })
                            .then((response) => {
                              window.location.href = `/client/treatment-diagnose/add-treatment/diagnose/${response.data.data._id}`;
                            })
                            .catch((error) => console.error(error));
                        }}
                        className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center hover:bg-emerald-100 transition-colors"
                        title="Add Treatment"
                      >
                        <MedicalInformationIcon sx={{ fontSize: 18 }} />
                      </button>
                    </>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <span className="text-xs text-slate-500 block mb-1">Time Slot</span>
                  <span className="px-2.5 py-1 bg-primary/10 text-primary rounded-md text-xs font-medium inline-block">
                    {item?.startTime} - {item?.endTime}
                  </span>
                </div>
                <div>
                  <span className="text-xs text-slate-500 block mb-1">Status</span>
                  <select
                    onChange={(e: any) => {
                      const status = e.target.value;
                      socket.emit("allAppointmentStatus", {
                        appointmentid: item?._id,
                        status: status,
                      });
                      baseUrl.patch("/appointment/statusAppointmentById", {}, {
                        headers: { appointmentid: item?._id, status: status },
                      })
                      .then(() => {
                        getAppointments(selectedOption, all);
                        appointmentCount();
                      })
                      .catch((error) => console.log(error));
                    }}
                    value={item?.status}
                    className={`px-2.5 py-1 rounded-lg text-xs font-medium border cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary/20 w-full ${
                      item?.status === "ongoing" ? "bg-lime-100 text-lime-700 border-lime-300" :
                      item?.status === "inqueue" ? "bg-sky-100 text-sky-700 border-sky-300" :
                      item?.status === "canceled" ? "bg-red-100 text-red-700 border-red-300" :
                      item?.status === "completed" ? "bg-emerald-100 text-emerald-700 border-emerald-300" :
                      item?.status === "appointment" ? "bg-orange-100 text-orange-700 border-orange-300" :
                      item?.status === "reschudle" ? "bg-cyan-100 text-cyan-700 border-cyan-300" :
                      item?.status === "noshow" ? "bg-slate-100 text-slate-700 border-slate-300" :
                      "bg-white text-slate-600 border-slate-200"
                    }`}
                  >
                    <option value="">Select</option>
                    <option value="appointment">Upcoming</option>
                    <option value="completed">Completed</option>
                    <option value="canceled">Canceled</option>
                    <option value="inqueue">In Queue</option>
                    <option value="ongoing">Ongoing</option>
                    <option value="noshow">No Show</option>
                  </select>
                </div>
                <div className="col-span-2">
                  <span className="text-xs text-slate-500 block mb-1">Purpose</span>
                  <p className="text-sm text-slate-700 font-medium">
                    {item?.purposeId?.purposeName || item?.bookTreatmentId?.name || "N/A"}
                  </p>
                </div>
                <div>
                  <span className="text-xs text-slate-500 block mb-1">Type</span>
                  <span className={`px-2.5 py-1 rounded-md text-xs font-medium inline-block ${
                    item?.type === "online" ? "bg-primary/10 text-primary" : "bg-emerald-100 text-emerald-700"
                  }`}>
                    {item?.type || "N/A"}
                  </span>
                </div>
              </div>
            </div>
          ))}
          {appointment?.myappointment?.length === 0 && (
            <div className="p-8 text-center text-slate-500">
              <p className="text-sm">No appointments found</p>
            </div>
          )}
        </div>

        <BottomTab title="Patient" count={counts} onPageChange={onPageChange} />
      </div>
    </div>
  );
}

export default YourAppointment;
